import { render, staticRenderFns } from "./ExpertOptions.vue?vue&type=template&id=5962be25&"
import script from "./ExpertOptions.vue?vue&type=script&lang=js&"
export * from "./ExpertOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VSwitch})
